import React from 'react';
import BaseReport from './BaseReport';

type Props = {
  data: any;
  studentNameMap?: { [studentId: string]: string };
};

const SkillReport = ({ data, studentNameMap }: Props) => {
  return (
    <BaseReport
      data={data}
      studentNameMap={studentNameMap}
      reportType="skill"
      showNoData={true}
      alwaysShowThreshold={false}
    />
  );
};

export default SkillReport;
